import { BREAK_POINT } from "../_defs";

/** モバイル識別用のメディアクエリ */
export const mobileQuery = window.matchMedia(
  `only screen and (max-width: ${BREAK_POINT}px)`
);
